module.exports = __webpack_public_path__ + "media/Pill-Transitions.e62aacc4.mp4";